import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PATH } from '@app/constants';
import { ImageOptimizerService } from '@app/services';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'mnf-new-card-project-list',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './new-card-project-list.component.html',
  styleUrl: './new-card-project-list.component.scss'
})
export class NewCardProjectListComponent {

  @Input() dev: any;
  path = PATH.ROUTE_PROJECTS_INFO;
  pathV2 = PATH.ROUTE_PROJECT_INFO_V2;

  constructor(
    private imageOptimizer: ImageOptimizerService
  ) {}

  public readonly urlBaseS3 = 'https://static.monific.com/assets/projects-images/';

  buildImageUrl(dev: any, urlBaseS3: string): string {
    let basePath = dev?.d?.baseProject == null ? dev?.d?.pid : dev?.d?.baseProject;
    let imageUrl = dev?.d?.img?.images?.[0] || dev?.d?.gallery?.[0];

    if (!imageUrl) {
      return '';
    }

    let fullUrl = urlBaseS3 + basePath + '/' + imageUrl;
    let urlParts = fullUrl.split("https://static.monific.com/assets/");
    if (urlParts.length > 2) {
      fullUrl = "https://static.monific.com/assets/" + urlParts.pop();
    }

    return this.imageOptimizer.getOptimizedImageUrl(fullUrl, 1440);
  }


  getProjectStateText(state: string): string {
    const stateTextMap = {
      'variable': 'Rendimiento variable',
      'fixed': 'Rendimiento fijo',
    };

    return stateTextMap[state] || 'Rendimento variable';
  }

}
